import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { DEFAULT_THREAD_TITLE, FileIconsSet, SVG_SIZE_M } from 'src/constants';
import { ArtifactType, SimpleThread } from 'src/types';
import {
  useBreakpoint,
  useConversationLink,
  useCurrentThreadId,
  useLeftPanelActions,
} from 'src/hooks';
import { Button } from 'src/v2/commonComponents/Button';
import { EditorMenuControl } from 'src/v2/components/Editor/components/EditorMenuControl';
import styles from './FileListItem.module.scss';

type FileListItemProps = {
  data: SimpleThread;
};

export const FileListItem = ({ data }: FileListItemProps) => {
  const navigate = useNavigate();
  const { isMobile } = useBreakpoint();
  const { toggleLeftPanelExpanded } = useLeftPanelActions();
  const { linkTo } = useConversationLink({ documentId: data.thread_id });

  const { currentThreadId } = useCurrentThreadId();

  const { thread_id, thread_title, thread_type } = data;

  const handleDocumentClick = async () => {
    if (isMobile) {
      toggleLeftPanelExpanded(false);
    }

    if (thread_id && thread_id !== currentThreadId) {
      navigate(linkTo);
    }
  };

  const CurrentIcon = thread_type ? FileIconsSet[thread_type] : undefined;
  const isSelected = thread_id === currentThreadId;
  const threadTitle = thread_title || DEFAULT_THREAD_TITLE;

  return (
    <div
      className={classNames(styles.root, {
        [styles.selected]: isSelected,
      })}
    >
      <Button
        color="transparent"
        className={styles.button}
        onClick={handleDocumentClick}
      >
        {CurrentIcon && (
          <CurrentIcon
            size={SVG_SIZE_M}
            className={classNames({
              [styles.text]: thread_type === ArtifactType.TEXT,
              [styles.code]: thread_type === ArtifactType.CODE,
            })}
          />
        )}

        <span className={styles.title}>{threadTitle}</span>
      </Button>

      {isSelected && (
        <EditorMenuControl
          threadId={thread_id}
          threadTitle={threadTitle}
          placement="left-menu"
        />
      )}
    </div>
  );
};
